<template>
	<div class="time-specifier">
		<BaseNumberInput
			v-model="hours"
			min="0"
		/>
		:
		<BaseNumberInput
			v-model="minutes"
			max="59"
			min="0"
		/>
		:
		<BaseNumberInput
			v-model="seconds"
			max="59"
			min="0"
		/>
	</div>
</template>

<script>
import growable from '@/directives/growable';
import BaseNumberInput from './BaseNumberInput.vue';

const timeToMs = (h = 0, m = 0, s = 0) => (h * 3600000) + (m * 60000) + (s * 1000);

export default {
	name: 'TimeSpecifier',
	components: {
		BaseNumberInput,
	},
	directives: {
		growable,
	},
	props: {
		value: {
			type: Number,
			default: () => 0,
		},
	},
	data() {
		return {
			hours: 0,
			minutes: 0,
			seconds: 0,
		};
	},
	watch: {
		value(value) {
			const hours = Math.floor(value / 3600000);
			const minutes = Math.floor((value - (timeToMs(hours))) / 60000);
			const seconds =
				Math.floor((value - (timeToMs(hours)) - (timeToMs(0, minutes))) / 1000);
			this.hours = hours;
			this.minutes = minutes;
			this.seconds = seconds;
		},
		hours(hours, oldHours) {
			if (!this.isWithin(0, Infinity, hours)) {
				this.hours = oldHours;
				return;
			}
			this.emit();
		},
		minutes(minutes, oldMinutes) {
			if (!this.isWithin(0, 60, minutes)) {
				this.minutes = oldMinutes;
				return;
			}
			this.emit();
		},
		seconds(seconds, oldSeconds) {
			if (!this.isWithin(0, 60, seconds)) {
				this.seconds = oldSeconds;
				return;
			}
			this.emit();
		},
	},
	methods: {
		emit() {
			this.$emit('input', timeToMs(this.hours, this.minutes, this.seconds));
		},
		reset() {
			this.hours = 0;
			this.minutes = 0;
			this.seconds = 0;
		},
		isWithin(min, max, val) {
			if (val < min) {
				return false;
			}
			if (val >= max) {
				return false;
			}
			return true;
		},
	},
};
</script>

<style lang="stylus" scoped>
.time-specifier
	display flex
	justify-content center
	align-items center
</style>



// WEBPACK FOOTER //
// src/components/TimeSpecifier.vue